import React from 'react'
import { faClockThreeThirtySolid, FaIcon } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DateField } from '@/ui/form/controls/DateField'
import { useCertificateStore } from '@/modules/drivers/stores/certificateStore'
import { TextField } from '@/ui/form/controls/TextField'
const CertificateDriverInfo = () => {
  const { t } = useLocalize()
  const { data, setData } = useCertificateStore()
  return (
    <div className="tw-flex tw-gap-4">
      <div className="tw-w-full tw-max-w-[200px] tw-space-y-2">
        <div className="tw-jusit tw-flex tw-flex-1 tw-items-center tw-gap-2 tw-font-medium tw-text-content-base">
          <FaIcon icon={faClockThreeThirtySolid} className="tw-max-w-[12px]" />
          <p className="tw-text-sm tw-font-semibold tw-text-content-base">
            Dane kierowcy
          </p>
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-3  tw-w-full">
        <div className="tw-flex tw-gap-3">
          <DateField
            required
            label={'Data urodzenia'}
            value={data?.birthDate}
            setValue={(e) => setData({ ...data, birthDate: e })}
            classNameWrapper="tw-flex tw-flex-col tw-justify-between"
          />
          <DateField
            label={'Data rozpoczęcia pracy w firmie'}
            value={data?.workStartDate}
            setValue={(e) => setData({ ...data, workStartDate: e })}
            classNameWrapper="tw-flex tw-flex-col tw-justify-between"
          />
        </div>
        <TextField
          label={'Numer prawaw jazdy / paszportu'}
          placeholder={t('common.type')}
          name="name"
          readOnly
          value={data?.drivingLicenceNumber}
          onChange={(e) => setData({ ...data, drivingLicenceNumber: e.target.value })}
        />
      </div>
    </div>
  )
}

export default CertificateDriverInfo
